import { t } from 'i18n';
import React, { useState } from 'react';
import { styled, Modal, ModalHeader } from '@teko/ds-desktop';
import { Cart } from 'modules/cart/desktop';
import { useCartV2, useTenantConfig } from 'contexts';
import { ConsultationServiceFee } from '@teko/ui-cart';
import { WarningNoLoyaltyMemberModal } from 'modules/cart/shared/WarningNoLoyaltyMemberModal';

interface PriceEditorProps {
  id: string;
  price: number;
  editedPrice: string;
  maxConsultationServiceFee?: number;
  defaultExpectedPrice: number;
}

const StyledModalHeader = styled(ModalHeader)`
  text-align: left;
  padding: 0;
  margin-bottom: 1em;
`;

const CartPage: React.FC = () => {
  const { cart, onChangeItemPrice } = useCartV2();
  const { numberDisplayFormat } = useTenantConfig();
  const [priceEditorData, setPriceEditorData] = useState<PriceEditorProps>({
    id: '',
    price: 0,
    editedPrice: '',
    maxConsultationServiceFee: 0,
    defaultExpectedPrice: 0,
  });
  const [showPriceEditor, setShowPriceEditor] = useState(false);
  const priceEditorError =
    !priceEditorData.editedPrice ||
    priceEditorData.price > Number(priceEditorData.editedPrice) ||
    Number(priceEditorData.editedPrice) >
      priceEditorData.price + Number(priceEditorData.maxConsultationServiceFee);

  const doEditPrice = (
    id: string,
    price: number,
    defaultExpectedPrice: number,
    maxConsultationServiceFee?: number,
  ) => {
    setShowPriceEditor(true);
    setPriceEditorData({
      id,
      price,
      maxConsultationServiceFee: maxConsultationServiceFee || 0,
      editedPrice: defaultExpectedPrice.toString(),
      defaultExpectedPrice,
    });
  };

  const doChangePrice = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPriceEditorData((prev: PriceEditorProps) => ({
      ...prev,
      editedPrice: event.target.value,
    }));
  };

  return (
    <>
      <Cart cartData={cart} onEditPrice={doEditPrice} />
      <Modal
        width="400px"
        visible={showPriceEditor}
        onClose={() => {
          setShowPriceEditor(false);
        }}
        showCloseIcon={false}
        contentStyle={{ padding: '2rem' }}
        onCancel={() => {
          setShowPriceEditor(false);
        }}
        onOk={async () => {
          setShowPriceEditor(false);
          await onChangeItemPrice(priceEditorData);
        }}
        okButtonProps={{ disabled: priceEditorError }}
        okText={'Xác nhận'}
        cancelText={'Hủy'}
        alignFooter="right"
      >
        <StyledModalHeader>{t('Thay đổi giá sản phẩm')}</StyledModalHeader>
        <ConsultationServiceFee
          isShow={showPriceEditor}
          sellingPrice={priceEditorData.price}
          maxConsultationServiceFee={
            priceEditorData.maxConsultationServiceFee ?? 0
          }
          onChangePrice={doChangePrice}
          defaultExpectedPrice={priceEditorData.defaultExpectedPrice}
          numberDisplayFormat={numberDisplayFormat}
        />
      </Modal>
      <WarningNoLoyaltyMemberModal />
    </>
  );
};

export default CartPage;
